<template>
  <div class="saleAll">
    <template v-for="(item, index) in saleAll">
      <sale-game :key="index" :item="item" />
    </template>
  </div>
</template>
<script>
import saleGame from '@/components/saleGame.vue'
import { discountlist } from '@/util/ourplay'
export default {
  components: {
    saleGame
  },
  data() {
    return {
      saleAll: []
    }
  },
  methods: {
    async initData () {
      let res = await discountlist()
      this.saleAll = res.data
    }
  },
  created () {
    this.initData()
  }
}
</script>
<style scoped>
.saleAll {
  padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/saleAll.vue